/**
 * 工作台双形态路由配置：
 * - 统一维护 desktop / h5 对照
 * - App 跳转、默认入口、纠偏跳转都应复用本配置
 */
export type DualRouteKey =
  | 'buyer'
  | 'centralProcurement'
  | 'approval'
  | 'platform'
  | 'supplier'
  | 'settingsCompany'
  | 'settingsUsers'
  | 'settingsWorkflows';

export type DualRouteConfig = {
  desktop: string;
  h5: string;
};

export const WORKBENCH_DUAL_ROUTES: Record<DualRouteKey, DualRouteConfig> = {
  buyer: { desktop: '/buyer', h5: '/buyer-h5' },
  centralProcurement: { desktop: '/central-procurement', h5: '/central-procurement-h5' },
  approval: { desktop: '/approval', h5: '/approval-h5' },
  platform: { desktop: '/platform', h5: '/platform-h5' },
  supplier: { desktop: '/supplier-desktop', h5: '/supplier-h5' },
  settingsCompany: { desktop: '/settings/company', h5: '/settings/company-h5' },
  settingsUsers: { desktop: '/settings/users', h5: '/settings/users-h5' },
  settingsWorkflows: { desktop: '/settings/workflows', h5: '/settings/workflows-h5' },
};

export function dualRoutePath(key: DualRouteKey, preferMobileLayout: boolean): string {
  const cfg = WORKBENCH_DUAL_ROUTES[key];
  return preferMobileLayout ? cfg.h5 : cfg.desktop;
}

export function oppositeDualRoutePath(
  key: DualRouteKey,
  preferMobileLayout: boolean,
): string {
  const cfg = WORKBENCH_DUAL_ROUTES[key];
  return preferMobileLayout ? cfg.desktop : cfg.h5;
}
